
export default {
  methods: {
    voltarAoCarrinho (id_pedido) {
      return this.$router.replace({ name: 'detalhes-carrinho', params: { id_pedido: id_pedido } })
    },
    voltarAoMinhasVendas () {
      this.$store.commit('minhasVendas/SET_IS_FILTROS_ANTERIORES', true)
      this.$router.replace({ name: 'minhas-vendas' })
    }
  }
}
